<script lang="ts" setup></script>
<template>
  <div class="page-footer">
    <!-- <div class="links">
      <a class="link" href="https://github.com/stepui/stepin-template" target="_blank"> Stepin 首页 </a>
      <a class="link" href="https://github.com/stepui/stepin-template" target="_blank">
        <GithubOutlined />
      </a>
      <a class="link" href="https://www.antdv.com/docs/vue/introduce-cn/" target="_blank"> Ant Design </a>
    </div> -->
    <div class="copyright">
      Copyright
      <CopyrightOutlined class="icon-copyright" /> <a href="https://etootech.com" target="_blank">2024 Atom 工作室出品</a>
    </div>
    <div class="icp">
      <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer">湘ICP备2026031698号-1</a>
    </div>
  </div>
</template>

<style scoped lang="less">
.page-footer {
  text-align: center;
  @apply text-gray-400;

  .links {
    display: flex;
    justify-content: center;

    .link {
      @apply hover:text-gray-400 pl-4 pr-4;
    }
  }

  .copyright {
    margin-top: 8px;

    .icon-copyright {
      margin: 0;
    }
  }

  .icp {
    margin-top: 4px;
    font-size: 12px;

    a {
      color: inherit;
      text-decoration: none;

      &:hover {
        color: #1890ff;
      }
    }
  }
}
</style>
